import React from "react";
import { Box, IconButton, Typography, alpha } from "@mui/material";
import { CalendarIcon, ClockIcon, KebabIcon, } from "@ui/components/icons/ReadingIcons";
import { DesignTooltip } from "@ui/components/tooltip/DesignTooltip";
import { TEMPERATURE_STATUS_COLORS } from "@ui/components/temperature";
const CARD_RADIUS = "32px";
/** Icon + text half of a two-column info row (Figma: Frame 126 / 127). */
const CardReading = ({ icon, label, tooltip, outOfRange }) => {
    const content = (React.createElement(Box, { sx: {
            flex: 1,
            minWidth: 0,
            height: 24,
            display: "flex",
            alignItems: "center",
            gap: "8px",
        } },
        React.createElement(Box, { sx: { display: "flex", flexShrink: 0 } }, icon),
        React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true, sx: outOfRange ? { color: TEMPERATURE_STATUS_COLORS[outOfRange].text, fontWeight: 600 } : undefined }, label)));
    return tooltip ? React.createElement(DesignTooltip, { title: tooltip }, content) : content;
};
export const CardReadingRow = ({ items }) => (React.createElement(Box, { sx: { display: "flex", height: 24 } }, items.map((item) => (React.createElement(CardReading, Object.assign({ key: item.label }, item))))));
/** 40px kebab button in the card header (Figma: IconButton / more-vertical). */
export const CardMenuButton = ({ onClick }) => (React.createElement(IconButton, { onClick: onClick, sx: { width: 40, height: 40, p: 0, flexShrink: 0, borderRadius: "500px" } },
    React.createElement(KebabIcon, null)));
/**
 * Stacked (tablet / mobile) counterpart of the AP details table row
 * (Figma: DeviceDetailsRow, Property 1=Default).
 */
export const DeviceDetailsCard = ({ tile, name, deviceId, menu, readings, readingTiles, date, time, status, badge, }) => (React.createElement(Box, { sx: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        p: 2,
        borderRadius: CARD_RADIUS,
        backgroundColor: "background.paper",
        // Inset ring instead of a border so the stroke never shifts the content.
        boxShadow: (theme) => `inset 0 0 0 1px ${alpha(theme.palette.grey[500], 0.24)}`,
    } },
    React.createElement(Box, { sx: { display: "flex", alignItems: "flex-start", gap: "12px" } },
        React.createElement(Box, { sx: { flexShrink: 0 } }, tile),
        React.createElement(Box, { sx: {
                flex: 1,
                minWidth: 0,
                height: 56,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            } },
            React.createElement(Typography, { variant: "body2", sx: { fontWeight: 600 }, noWrap: true }, name),
            React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true }, deviceId)),
        menu),
    readingTiles && readingTiles.length > 0 ? (
    // Bottom padding leaves room for the tiles' shadow.
    React.createElement(Box, { sx: { display: "flex", flexWrap: "wrap", gap: "12px", pb: 1 } }, readingTiles)) : (readings && readings.length > 0 && React.createElement(CardReadingRow, { items: readings })),
    React.createElement(CardReadingRow, { items: [
            { icon: React.createElement(CalendarIcon, null), label: date },
            { icon: React.createElement(ClockIcon, null), label: time },
        ] }),
    React.createElement(Box, { sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: 32,
        } },
        status,
        badge)));
